import { NgModule } from '@angular/core';
import { ResidentRoutingModule } from './resident-routing.module';
import { SharedModule } from '../shared/shared.module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';


import { ResidentService } from './resident.service';
import { ParkingDetailsComponent } from './parking-details/parking-details.component';
import { WaiverRegisterComponent } from './waiver-register/waiver-register.component';
import { WaiverSummaryComponent } from './waiver-summary/waiver-summary.component';

import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatCheckbox, MatCheckboxModule } from '@angular/material/checkbox';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ResidentRoutingModule,
        MatSelectModule,
        SharedModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatAutocompleteModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatCheckboxModule,
        MatDialogModule
    ],
    providers: [ResidentService],
    exports: [
    ],
    declarations: [
        ParkingDetailsComponent,
        WaiverRegisterComponent,
        WaiverSummaryComponent,

    ]
})
export class ResidentModule { }
